import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as l, useEffect as u, useRef as a } from "react";
function k(t, e) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _c$storagePrefix = c.storagePrefix,
    f = _c$storagePrefix === void 0 ? "use-persistent-state-" : _c$storagePrefix,
    _c$storage = c.storage,
    n = _c$storage === void 0 ? localStorage : _c$storage,
    r = f + t,
    _l = l(function () {
      var o = n.getItem(r);
      return o === null ? typeof e == "function" ? e() : e : JSON.parse(o);
    }),
    _l2 = _slicedToArray(_l, 2),
    s = _l2[0],
    i = _l2[1];
  return u(function () {
    n.setItem(r, JSON.stringify(s));
  }, [s, r, n]), [s, i];
}
function E(t) {
  var e = a();
  return u(function () {
    e.current = t;
  }, [t]), e.current;
}
function y() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }
  return t.filter(function (e) {
    return !!e;
  }).join(" ");
}
var m = y;
function K(t) {
  return function (e) {
    e.key === "Enter" && t(e);
  };
}
function g(t) {
  return function (e) {
    (e.key === "Enter" || e.key === " ") && t(e);
  };
}
function x(t) {
  return function (e) {
    e.key === "Escape" && t(e);
  };
}
function b(t, e) {
  return {
    role: "button",
    tabIndex: e !== null && e !== void 0 ? e : 0,
    onKeyDown: g(t),
    onClick: t
  };
}
export { b as accessibleOnClick, m as cn, y as concatClassNames, K as filterKeyEnter, x as filterKeyEsc, g as filterKeyTriggerButton, k as usePersistentState, E as usePrevious };